import React from "react";
import { Form, Input } from "antd";
import { intlPlaceholder } from "util/intlPlaceholder";
const PetMainCategoryForm = () => {
  return (
    <Form.Item
      className="gx-px-3"
      name="name"
      label={intlPlaceholder("petMainCategory.filedName")}
      rules={[
        {
          required: true,
          message: intlPlaceholder("petMainCategory.name_Message"),
        },
      ]}
    >
      <Input
        placeholder={intlPlaceholder("petMainCategory.filedName_Placeholder")}
      />
    </Form.Item>
  );
};

export default PetMainCategoryForm;
